import fp from 'lodash/fp'
import { combine, withCallback } from 'react-hooks-combine'

import FileInputComponent from './component'

export default combine(
  withCallback(
    'onInternalChange',
    (_state, props) => (event) => {
      const { files, value } = event.target
      const fileToUpload = fp.head(files)
      const fileWrapper = {
        file: fileToUpload,
        toString() {
          return value
        },
      }

      fp.invokeArgs('onChange', [{ target: { value: fileWrapper } }], props)
    },
    []
  )
)(FileInputComponent)
